import React from 'react';
import { ACTIONS_TYPES } from 'redux/local';
import Section from 'screens/shared/section';
import Util from 'screens/shared/utilities';
import { createLink, _t } from 'utils';
import { ROUTE } from 'constant';
import CreateForm from './create';

export default ({ natGateways = [], history = {}, dcId }) => (
  <Section
    sectionTitle={_t('NAT Gateway')}
    createForm={<CreateForm dcId={dcId} />}
    createActionType={ACTIONS_TYPES.NAT_GATEWAY.CREATE}
    className="-m-t-24"
    isDeletePassword
    items={natGateways}
    itemIcon="sitemap"
    setItemTitle={(e) => e.properties?.name}
    setItemDetails={(e) => (
      <div className="flex">
        {e.properties?.lans.map((x) => <Util.LAN id={x?.id} key={x?.id} />)}
        <Util.IPs ips={e.properties?.publicIps} className="m-l-15" />
      </div>
    )}
    itemOnClick={({ id }) => history.push(createLink(ROUTE.DASHBOARD.NAT_GATEWAY, { dcId, id }))}
  />
);
